import React, {useCallback} from "react";
import sunny from "../../images/weather/sunny.svg"
import rainy from "../../images/weather/rainy.svg"
import stormy from "../../images/weather/stormy.svg"
import cloudy from"../../images/weather/cloudy.svg"
import question from "../../images/weather/questionmark.svg"
import ProjectCard from "./ProjectCard";
import {removeDuplicatesInArray} from "../../utils/utils";
import styled from "styled-components";
import axisDefault from "../../images/axis/axis.svg"
import account from "../../images/account.svg"
import {getImage} from "../../utils/utils";
import {CircularProgressBar} from "../progress-bar/CircularProgressBar";
import {sliceText} from "./utils";

const AxisDetail = ({axis, pilotsId, years, weathers, tags ,fromPreview, asideObjective, showKR, users}) => {
    const projects = axis.stakes.map( s => s.projects).flat();
    const filterPredicate = useCallback(
        (p) => {
            let year;

            if (p.endDate) {
                year = new Date(p.endDate).getFullYear();
            } else if (p.startDate) {
                year = new Date(p.startDate).getFullYear();
            } else if (p.lastUpdate) {
                year = new Date(p.lastUpdate).getFullYear();
            }
            const pilotFilter =
                pilotsId?.length === 0 || pilotsId?.includes(p.pilot?.id);
            const weatherFilter =
                weathers?.length === 0 || weathers?.includes(p.weather);

            const tagsFilter =
                tags?.length === 0 ||
                tags?.some((t) => p.tags?.map((n) => n.name).includes(t)) ||
                tags?.some((t) => p.tags?.map((n) => n.category).includes(t));
            const yearFilter =
                (years?.length === 0) || years?.includes(year);
            return (
                pilotFilter &&
                yearFilter &&
                weatherFilter &&
                tagsFilter
            );
        },
        [pilotsId, years, weathers, tags]
    );
    const filteredProjects = axis.stakes.map( s => {
            return (fromPreview ? s.projects : s.projects.filter(filterPredicate))
    }).flat();
    const actions = projects.map(p => p.actions).flat()
    const objectives = filteredProjects.map(p => p.okrs).flat()
    const doneProjects = projects.filter(p => p.advancement === 100)
    const doneActions = actions.filter(a => a.advancement === 100)
    const lateProjects = projects.filter((p) =>
        p.endDate &&
        new Date(p.endDate) <= new Date() &&
        p.advancement < 100)
    const lateActions = actions.filter((a) =>
        !!a.deadline &&
        new Date(a.deadline) <= new Date() &&
        a.advancement < 100)
    const pilots = removeDuplicatesInArray(projects.map(p => p.pilot))
    const weatherTranslate = (weather) => {
        switch (weather) {
            case "sunny":
                return 1;
            case "cloudy":
                return 2;
            case "rainy":
                return 3;
            case "stormy":
                return 4;
            case null:
                return 5;
            default:
                return null;
        }
    };
    const projectOrdered = filteredProjects.sort((p1, p2) => {
        return weatherTranslate(p1.weather) - weatherTranslate(p2.weather);
    })

    const stakes = axis.stakes.length > 5 ? axis.stakes.slice(0,4) : axis.stakes;
    const strength = axis.swots.filter(i => i.type === "strength")
    const weakness = axis.swots.filter(i => i.type === "weakness")
    const opportunities = axis.swots.filter(i => i.type === "opportunity")
    const threats = axis.swots.filter(i => i.type === "threat")

    const projectsByStakes = (stake) => {

        const newFilteredProjects = (fromPreview ? stake.projects : stake.projects.filter(filterPredicate)).flat();
        const newProjectOrdered = newFilteredProjects.sort((p1, p2) => {
            return weatherTranslate(p1.weather) - weatherTranslate(p2.weather);
        })
        return(
            <>
                {
                    newProjectOrdered.map(p => {
                        return <>
                            <ProjectCard project={p} key={p.id} type={"project"} users={users}/>
                            {   !asideObjective &&
                            p.okrs?.length > 0 ? <p className={"mini-title"}>Objectifs ({p.okrs?.length}):</p> : null}
                            { !asideObjective &&
                                p.okrs?.map(o => {
                                    return <>
                                        <ProjectCard project={o} okr={true} key={o.id} type={"objective"} users={users}/>
                                        {(o.keyResults.length > 0 && showKR) ? <p style={{marginLeft: "10%"}} className={"mini-title"}>Indicateurs ({o.keyResults.length}):</p> : null}
                                        {
                                            showKR &&
                                            o.keyResults?.map(kr => {
                                                return <ProjectCard project={kr} key={kr.id} type={"kr"} users={users}/>
                                            })
                                        }
                                    </>
                                })}
                        </>
                    })
                }
            </>
        )
    }


    return (
        <>
            <AxisDetailContainer>
                <AxisDetailData>
                    <div className="axis-stakes">
                        <div className="axis">
                            <div className="axis-frame">{axis.name}</div>
                            <div className="axis-frame-data">
                                <div className="img-chart">
                                    <img src={getImage(axis.image, axisDefault)} alt=""/>
                                    <CircularPB>
                                        {CircularProgressBar(Math.round(axis.stakeAdvancementAVG))}
                                    </CircularPB>
                                </div>
                            </div>
                        </div>
                        <div className="stakes">
                            <h3>Enjeux de cet axe :</h3>
                            {
                                axis.stakes.map(s => {
                                    return (
                                        <div className="stakes-card" key={s.id}>
                                            <p> {sliceText(s.name, 100, "[...]")}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="axis-data">
                        {
                            axis.sponsor &&

                            <div className="axis-identity">
                                <div className="sponsor">
                                    <p>Sponsor :</p>
                                    <div>
                                        <img src={getImage(axis.sponsor.photo, account)} alt=""/>
                                        <p>{axis.sponsor?.firstName} {axis.sponsor?.lastName} </p>
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="axis-data-inner">
                            <div className="axis-numbers">
                                <div className="numbers-card" style={{background: "#4BB472FF"}}>
                                    {doneProjects.length} {doneProjects.length > 1 ? "Projets terminés" : "Projet terminé"}
                                </div>
                                <div className="numbers-card" style={{background: "#E9405B"}} >
                                    {lateProjects.length} {lateProjects.length > 1 ? "Projets" : "Projet"}  en retard
                                </div>
                                <div className="numbers-card">
                                    {(projects.length / pilots.length).toFixed(2)} {projects.length > 1 ? "Projets" : "Projet"} / pilote
                                </div>
                                <div className="numbers-card" style={{background: "#4BB472FF"}}>
                                    {doneActions.length} {doneActions.length > 1 ? "Actions terminées" : "Action terminée"}
                                </div>
                                <div className="numbers-card" style={{background: "#E9405B"}} >
                                    {lateActions.length} {lateActions.length > 1 ? "Actions" : "Action"} en retard
                                </div>
                                <div className="numbers-card">
                                    {actions.length} {actions.length > 1 ? "Actions" : "Action"}
                                </div>
                            </div>
                            <div className="axis-data-col2">
                                <div className="weather-count">
                                    <img src={sunny} alt=""/>
                                    <p>{projects.filter(p => p.weather === "sunny").length}</p>
                                </div>
                                <p className={"weather-legend"}>plein soleil</p>
                                <div className="weather-count">
                                    <img src={cloudy} alt=""/>
                                    <p>{projects.filter(p => p.weather === "cloudy").length}</p>
                                </div>
                                <p className={"weather-legend"}>éclaircie</p>

                                <div className="weather-count">
                                    <img src={rainy} alt=""/>
                                    <p>{projects.filter(p => p.weather === "rainy").length}</p>
                                </div>
                                <p className={"weather-legend"}>pluie</p>

                                <div className="weather-count">
                                    <img src={stormy} alt=""/>
                                    <p>{projects.filter(p => p.weather === "stormy").length}</p>
                                </div>
                                <p className={"weather-legend"}>tempête</p>

                                <div className="weather-count">
                                    <img src={question} alt=""/>
                                    <p>{projects.filter(p => p.weather === null).length}</p>
                                </div>
                                <p className={"weather-legend"}>à déterminer</p>

                            </div>
                        </div>
                    </div>
                </AxisDetailData>
                <SwotBlock>
                    <h3 className="swot-title"><span style={{color: "#4BB472FF"}}>S</span><span
                        style={{color: "#3394F6"}}>W</span><span style={{color: "#FFB400FF"}}>O</span><span
                        style={{color: "#E9405BFF"}}>T</span></h3>
                    <SwotContainer>
                        <div className={"strength swot-items"}>
                            <h3>Forces</h3>
                            {strength.length > 0 ? strength.map((s) => {
                                return (
                                    <p>{s.content}</p>
                                )
                            }) : "à compléter"}
                        </div>
                        <div className={"weakness swot-items"}>
                            <h3>Faiblesses</h3>
                            {weakness.length > 0 ? weakness.map((w) => {
                                return (
                                    <p>{w.content}</p>
                                )
                            }) : "à compléter"}
                        </div>
                        <div className={"opportunities swot-items"}>
                            <h3>Opportunités</h3>
                            {opportunities.length > 0 ? opportunities.map((o) => {
                                return (
                                    <p>{o.content}</p>
                                )
                            }) : "à compléter"}
                        </div>
                        <div className={"threats swot-items"}>
                            <h3>Menaces</h3>
                            {threats.length > 0 ? threats.map((t) => {
                                return (
                                    <p>{t.content}</p>
                                )
                            }) : "à compléter"}
                        </div>
                    </SwotContainer>
                </SwotBlock>
            </AxisDetailContainer>
            {
                projects.length > 0 &&

                <ProjectListStyle  className={"break-before"} >
                    <div className="list-banner">
                        <div className="icon"></div>
                        {asideObjective ?
                            <p>{projects.length > 1 ? "Les " + projects.length + " projets" : "Le projet"} de l'axe
                                : {axis.name}</p>
                            :
                            <p>{projects.length > 1 ? "Les projets" : "Le projet"} {objectives.length > 0 ? objectives.length> 1 ? "et les objectifs" : "et l'objectif" : null} de l'axe
                                : {axis.name}</p>
                        }
                    </div>
                    {
                        axis.stakes.map(stake => {
                            if(stake.projects.length > 0){
                                return <ProjectsByStake>
                                    <h4> Enjeu : {stake.name} </h4>
                                    {projectsByStakes(stake)}
                                </ProjectsByStake>
                            }
                        })
                    }
                    {/*
                    {
                        projectOrdered.map(p => {
                            return <>
                                <ProjectCard project={p} key={p.id} type={"project"} users={users}/>
                                <ProjectListStyle>
                                    {   !asideObjective &&
                                    p.okrs.length > 0 ? <p className={"mini-title"}>Objectifs ({p.okrs.length}):</p> : null}
                                    { !asideObjective &&
                                        p.okrs.map(o => {
                                            return <>
                                                <ProjectCard project={o} okr={true} key={o.id} type={"objective"} users={users}/>
                                                <ProjectListStyle>
                                                    {(o.keyResults.length > 0 && showKR) ? <p style={{marginLeft: "10%"}} className={"mini-title"}>Indicateurs ({o.keyResults.length}):</p> : null}
                                                    {
                                                        showKR &&
                                                        o.keyResults.map(kr => {
                                                            return <ProjectCard project={kr} key={kr.id} type={"kr"} users={users}/>
                                                        })
                                                    }
                                                </ProjectListStyle>
                                            </>
                                        })}
                                </ProjectListStyle>
                            </>
                        })
                    }

                    */}
                </ProjectListStyle>
            }
            {
                objectives.length > 0 && asideObjective &&

                <ProjectListStyle  className={"break-before"} >
                    <div className="list-banner">
                        <div className="icon"></div>
                        <p>{objectives.length > 1 ? "Les " + objectives.length + " objectifs" : "L'objectif "} de l'axe
                            : {axis.name}</p>
                    </div>
                    {
                        objectives.map(o => {
                            return (
                                <ProjectCard project={o} okr={true} key={o.id}/>
                            )
                        })
                    }
                </ProjectListStyle>
            }
        </>
    )
}

const Separator = styled.div`
    display: block;
    width: 100%;
    height: 1px;
    padding: 0;
    margin: 3.5rem 0;
    background: black;
`

const CircularPB = styled.div`
    width: 100%;

    #circular-progress-bar div svg {
        max-width: 80%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }

    .rc-progress-circle {
        max-width: 60px;
    }

    #circular-progress-bar div h4{
    bottom: 3.6rem;
    font-size: 1.2rem;
  }
  @media print{
    max-width: 50%;
    #circular-progress-bar div svg  {
      max-width: 60%;
      height: 100%;
      justify-content: center;
      align-items: center;
    }
    .rc-progress-circle {
      max-width: 50%;
    }
    #circular-progress-bar div h4{
      bottom: 2.6rem;
      font-size: 1rem;
    }
  }
`
const AxisDetailContainer = styled.div`
  @media print{
    page-break-inside: avoid;
  }
  .swot-title{
    font-size: 30px;
    text-align: center;
    font-weight: bolder;
    margin: auto;
    max-width: 30%;
    text-shadow: 1px 1px 3px rgba(0,0,0,0.5);
    -webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
  }
`
const AxisDetailData = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  @media screen and (min-width: 900px){
    gap: 0.6rem;
    display: grid;
    grid-template-columns: repeat(2, minmax(25%,1fr));
  }
  
  @media print{
    padding: 0.8rem;
    gap: 0.6rem;
    page-break-inside: avoid;
    display: grid;
    grid-template-columns: repeat(2, minmax(25%,1fr));
  }

  .axis-stakes{
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
  }

  .axis{
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
    -webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
    border-radius: 15px;
  }

  .axis img {
    max-width: 35%;
  }

  .axis-frame{
    padding: 0.6rem;
    text-align: center;
    background: #4909aa;
    color: white;
    text-transform: uppercase;
    font-weight: bolder;
    font-size: 22px;
    @media print{
      font-size: 14px;
    }
  }

  .axis-frame-data{
    display: flex;
    flex-direction: column;
    padding: 1rem;
    justify-content: center;
    align-items: center;
  }
  .axis-frame-data .img-chart {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .img-chart img{
    width: 200px;
    object-fit: contain;
  }

  .axis-frame-data .axis-title{
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
    
    @media print{
      font-size: 18px;
      
    }
  }
  .weather-block{
    display: flex;
    flex-direction: column;
    gap:1rem;
  }

  .weather-card{
    display: grid;
    grid-template-columns: 20% 75%;
    gap: 1.5rem;
  }

  .weather-count img{
    width: 80%;
  }
  .weather-count{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
    -webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
  }

  .weather-count p {
    font-size: 22px;
    font-weight: bold;
    margin: 0;
    @media screen and (min-width: 1350px){
      font-size: 22px;
    }
    
    @media print {
      font-size: 22px;
    }
  }

  .weather-desc{
    text-align: right;
    align-self: center;
    color: #4909aa;
    font-size: 22px;
  }
  .stakes{
    display: grid;
    gap: 0.2rem;
      
    @media print {
        max-height: 200px;
        overflow-y: hidden;
    }
  }
  
  .stakes h3 {
    padding: 0.4rem;
    text-align: center;
    background: #4909aa ;
    font-size: 20px;
    color: white;
    margin: 0.2rem 0;
    @media screen and (min-width: 1300px){
      font-size: 26px;
    }
    @media print {
      font-size: 14px;
      
    }
  }
  
  .stakes-card{
    padding: 0.4rem;
    background: #eee;
    border-radius: 15px;
  }
  .stakes-card p {
    font-size: 18px;
    
    @media print{
      font-size: 9px;
    }
  }
  .axis-data{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: auto;
    align-items: center;
    @media screen and (min-width: 900px){
      width: 100%;
      margin: 0;
      align-self: baseline;
    }
  }
  .axis-data-inner{
    width: 90%;
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: 60% 30%;    
    @media screen and (min-width: 1350px){
      grid-template-columns: 50% 30%;
    }
        @media print{
      grid-gap: 1.5rem;
      grid-template-columns: 50% 50%;      
    }    
  }


  .axis-data-inner .weather-count{
    padding: 0.5rem;
  }
  .axis-data-inner .weather-count img{
    width:50%;
  }
  .axis-data-col2{
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: repeat(1, minmax(85px, 85px));
    grid-template-rows: repeat(5, minmax(85px, 85px));
    gap: 0.5rem;
    justify-content: center;

    @media screen and (min-width: 900px){
        grid-template-columns: repeat(2, minmax(80px, 80px));
        grid-template-rows: repeat(5, minmax(80px, 80px));
        gap: 0.5rem;
    }  
    @media screen and (min-width: 1350px){
      grid-template-columns: repeat(2, minmax(100px, 100px));
      grid-template-rows: repeat(5, minmax(100px, 100px));
      gap: 0.5rem
    }    
    @media print{
        grid-template-columns: repeat(1, minmax(50px, 50px));
        grid-template-rows: repeat(5, minmax(50px, 50px));
        gap: 0.5rem;
    }
    p{
      font-size: 12px;
      align-self: center;
      color: #4909aa;
    }
      .weather-legend{
        display: none;
          
        @media screen and (min-width: 900px){
            display: block;
        }  
      }
  }
    

  .axis-numbers{
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: repeat(2,minmax(100px, 150px));
    grid-template-rows: repeat(3,minmax(100px, 150px));
    
    @media screen and (min-width: 900px){
      grid-template-columns: repeat(2,minmax(100px, 150px));
      grid-template-rows: repeat(3,minmax(100px, 150px));
    }
    
    @media screen and (min-width: 1350px){
      grid-template-columns: repeat(2,minmax(100px, 180px));
      grid-template-rows: repeat(3,minmax(100px, 180px));
    }
    
    @media print{
      grid-template-columns: repeat(2,minmax(90px, 100px));
      grid-template-rows: repeat(3,minmax(80px, 90px));
    }
  }
  .numbers-card{
    display: flex;
    padding: 0.4rem;
    background: #FFB400;
    border-radius: 10px;
    color: white;
    text-align: center;
    font-size: 16px;
    font-weight: bolder;
    justify-content: center;
    align-items: center;
    
    @media screen and (min-width: 900px){
      font-size: 16px;
    }
    @media print{
      font-size: 13px;
    }
  }
  .axis-identity{
    text-align: center;
    display: grid;
   
  }
  .sponsor{
    display: flex;
    flex-direction: column;
    padding: 0.5rem;
    border-radius: 15px;
    background-color: #eee;
    gap: 0.25rem;
    
    @media print{
      .sponsor div p {
        font-size: 14px;
      }
    }
  }
  .sponsor p {
    margin: 0;
    font-size: 20px;
  }

  .sponsor div {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    @media print{
      gap:0.5rem;
    }
  }

  .sponsor div img {
    border-radius: 50%;
    height: 50px;
    width: 50px;
    
    @media print{
      height: 35px;
      width: 35px;
    }
  }
`
const SwotBlock = styled.div`
    @media print {
        page-break-inside: avoid;
    }
`

const SwotContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(150px, 100%));
  grid-template-rows: repeat(4, minmax(300px, 300px));
  justify-content: center;
  gap: 0.5rem;
  max-width: 90%;
  margin: auto;
  overflow: hidden;
  @media screen and (min-width: 900px){
    grid-template-columns: repeat(2, minmax(150px, 50%));
    grid-template-rows: repeat(2, minmax(150px, 300px));
  }
  @media print{
    page-break-inside: avoid;
    grid-template-columns: repeat(2, minmax(150px, 50%));
    grid-template-rows: repeat(2, minmax(150px, 250px));
  }
  .swot-items{
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
    -webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
    padding: 0.8rem;
    color: white;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    overflow: hidden;
    p{
      font-size: 12px;
      color: white;
      font-weight: bold;
      @media print {
        font-size: 10px;
      }
    }
    h3{
      color: white;
      font-size: 20px;
      text-align: center;
      font-weight: bolder;
      
      @media print {
        font-size: 18px;
      }
    }
  }
  .strength{
    background-color: #52D783;
  }
  
  .weakness{
    background-color: #3394F6;
  }
  
  .opportunities{
    background-color: #FFB400;
  }
  
  .threats{
    background-color: #ff4754;
  }
`

const ProjectListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  @media print{
    page-break-inside: avoid;
  }
  .break-before{
      @media print {
          page-break-before: always;
      }
  }
  .mini-title{
      font-size: 12px;
      margin-left: 5%;
      color: var(--color-purple);
      font-weight: bolder;
      padding: 0.5rem 0;
  }
  .list-banner{
    padding: 0.4rem;
    text-align: center;
    background: #4909aa ;
    font-size: 26px;
    color: white;
    margin: 1rem 0;
    margin-top: 1.5rem;
  }

  .list-banner p{
    color: white;
    margin: 0;
    font-size: 26px;
    @media print{
      font-size: 22px
    }
  }
`

const ProjectsByStake = styled.div`
    display: flex;
    flex-direction: column;
    h4{
        background-color: var(--color-purple-lighten);
        padding: 0.5rem;
        color: var(--color-purple);
        font-weight: bold;
        font-size: 15px;
        border-radius: 10px;
        text-align: center;
    }
`
export default AxisDetail